import React, { useState } from 'react';
import { faCheck, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
//Components
import Stepper from '../../../components/Stepper/Stepper';
import MainCard from '../../../components/MainCard/MainCard';
import IdentificacaoRota from './components/IdentificacaoRota';
import ListaGeradores from './components/ListaGeradores';
import ContainerFichaOrdemColeta from './components/ContainerFichaOrdemColeta';
import Loading from '../../../components/Loading/Loading';

//Api
import programacaoColeta_api from '../../../api/programacaoColeta_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Estado inicial para o estado de cadastro da rota de coleta/ ordem
function initialStateOrdemColeta(ordemColeta) {
    return {
        id: ordemColeta ? ordemColeta.id : 0,
        tbRotaColeta_Id: ordemColeta ? ordemColeta.tbRotaColeta_Id ? ordemColeta.tbRotaColeta_Id : "0" : "0",
        descricao: ordemColeta ? ordemColeta.descricao : "Ordem Avulsa",
        dataColeta: ordemColeta ? moment(ordemColeta.dataColeta).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        status: ordemColeta && ordemColeta.id && ordemColeta.status ? ordemColeta.status : "Programada",
        tbDestinos_Id: ordemColeta ? ordemColeta.tbDestinos_Id : "",
        tbVeiculos_Id: ordemColeta ? ordemColeta.tbVeiculos_Id : "",
        tbUsuarios_Operador_Id: ordemColeta ? ordemColeta.tbUsuarios_Operador_Id ? ordemColeta.tbUsuarios_Operador_Id.toString() : ordemColeta.tbUsuarios_Operador_Id : "",
        tbVeiculos_Placa: ordemColeta ? ordemColeta.tbVeiculos_Placa : "",
        tbDestinos_Fantasia: ordemColeta ? ordemColeta.tbDestinos_Fantasia : "",
        items: ordemColeta ? ordemColeta.items : [],
    }
}

export default function NovaOrdem({ permissao, ordemColeta = null, Manutencao = null, btnVoltar }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado de validação de campos
    const [errors, setErrors] = useState({});
    //Estado que guarda o passo ativo do cadastro/Edição
    const [activeStep, setActiveStep] = useState(1);
    //Controle da apresentação do formulario de cadastro/edição
    const [openFormListaGeradore, setOpenFormListaGeradores] = useState(false);
    const toggleFormListaGeradores = () => setOpenFormListaGeradores(!openFormListaGeradore);

    //Estado de controle dos dados da rota de coleta
    const [ordem, setOrdem] = useState(initialStateOrdemColeta(ordemColeta));
    const camposIdentificacao = [
        objCampo({ required: true, name: "descricao" }),
        objCampo({ required: true, name: "tbVeiculos_Id" }),
        objCampo({ required: true, name: "tbDestinos_Id" }),
        objCampo({ required: true, name: "tbUsuarios_Operador_Id" })
    ]
    const validarCamposIdentificacao = () => {

        const _errors = validarCampos(ordem, camposIdentificacao);
        setErrors(_errors[0]);
        return _errors[1];
    }
    const validarListaGeradores = () => {
        if (ordem.items.length === 0 || ordem.items.filter(value => !value.excluido).length === 0) {
            showMessage("Aviso", "Informe ao menos um ponto de coleta para passar para o proximo passo", "info", null);
            return ["Informe ao menos um ponto de coleta para passar para o proximo passo"];
        }
        return [];
    }
    //Passos do cadastro/edição
    const steps = [
        { text: "Identificação da rota", icon: faPencilAlt, validateStep: validarCamposIdentificacao },
        { text: "Lista de geradores", icon: faPencilAlt, validateStep: validarListaGeradores, btnAdicionar: toggleFormListaGeradores, btnAdicionarText: Manutencao && Manutencao.id ? "+ Adicionar coleta extraordinária" : null },
        { text: "Finalizar", icon: faCheck },
    ]
    const onSubmit = () => {
        setLoading(true);
        if (ordemColeta && ordemColeta.id !== 0) {
            programacaoColeta_api.Put(ordem).then(response => {
                showMessage("Sucesso", "Ordem de coleta atualizada com sucesso", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
            }).finally(f => setLoading(false));
        } else {
            programacaoColeta_api.Post(ordem).then(response => {
                showMessage("Sucesso", "Ordem de coleta programada com sucesso", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
            }).finally(f => setLoading(false));
        }
    }

    //Retorna o conteudo do passo ativo
    const getSteps = () => {

        switch (activeStep) {
            case 1: {
                return (
                    <IdentificacaoRota campos={camposIdentificacao} errors={errors} setErrors={setErrors} setOrdemColeta={setOrdem} ordemColeta={ordem} />
                );
            }
            case 2: {
                return (
                    <ListaGeradores ordemColeta={ordem} setOrdemColeta={setOrdem} permissao={permissao} idRotaManutencao={null} openForm={openFormListaGeradore} setOpenForm={setOpenFormListaGeradores} />
                )
            }
            case 3: {
                return (
                    <ContainerFichaOrdemColeta ordemColeta={ordem} />
                )
            }
        }
    }


    return (
        <MainCard btnVoltar={btnVoltar}>
            {loading && <Loading />}
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Stepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} onSubmit={onSubmit}>
                {getSteps()}
            </Stepper>
        </MainCard >
    )
}